import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { BookingService } from '../../services/booking.service';
import { Component, Injector, OnInit } from '@angular/core';
import { DropdownOptionsService } from './../../../../core/services/dropdown-options.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { finalize } from 'rxjs/operators';
import { BillService } from '../../../bill/service/bill.service';
import { FacilityService } from 'src/app/core/services/facility.service';

@Component({
  selector: 'laas-booking-header-detail',
  templateUrl: './booking-header-detail.component.html',
  styleUrls: ['./booking-header-detail.component.scss'],
})
export class BookingHeaderDetailComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewQueryBookingForShipping;

  bookingModel: any;
  vendorOptions: any[];
  carrierPaymentTypeOptions: any[];
  deliveryTypeOptions: any[];
  deliverSubTypeOptions: any[];
  bookingTypeOptions: any[];
  chargeOptions: any[];
  forwarderOptions: any[];
  carTypeOptions: any[];
  carSeqOptions: any[];
  letterHeadOptions: any[];
  billCorpOptions: any[];
  pickupLocationOptions: any[];
  incoTermOptions: any[];
  bookingStatusOptions: any[];
  rfqAreaOptions: any[];
  facilityOptions: any[];
  payTypeOptions: any[];
  shipMethodOptions: any[];
  isShowEditBtn: boolean;
  isShowEditRelatedBillBtn: boolean;
  isShowCancelBtn: boolean;
  isShowUpdateBtn: boolean;
  containerCheckDescription: any;
  isShowEditRelatedBill: boolean;

  countryOptions: any[];
  cityOptions: any[];
  toAreaOptions: any[];
  toAirportOptions: any[];

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private dropdownOptionService: DropdownOptionsService,
    private facilityService: FacilityService,
    private billService: BillService
  ) {
    super(injector);

    this.vendorOptions = [];
    this.bookingModel = {};
    this.forwarderOptions = [];
    this.carTypeOptions = [];
    this.carSeqOptions = [];
    this.letterHeadOptions = [];
    this.billCorpOptions = [];
    this.carrierPaymentTypeOptions = [];
    this.deliveryTypeOptions = [];
    this.deliverSubTypeOptions = [];
    this.bookingTypeOptions = [];
    this.chargeOptions = [];
    this.pickupLocationOptions = [];
    this.incoTermOptions = [];
    this.bookingStatusOptions = [];
    this.rfqAreaOptions = [];
    this.facilityOptions = [];
    this.payTypeOptions = [];
    this.shipMethodOptions = [];
    this.isShowEditBtn = false;
    this.isShowEditRelatedBillBtn = false;
    this.isShowCancelBtn = false;
    this.isShowUpdateBtn = false;
    this.isShowEditRelatedBill = false;

    this.countryOptions = [];
    this.cityOptions = [];
    this.toAreaOptions = [];
    this.toAirportOptions = [];

    this.translateService.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();
  }

  translationLabel() {
    // Container Check Description
    this.containerCheckDescription = this.translateService.instant(
      'BookingSearch.Confirm.ContainerCheck'
    );
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionService.getPayTypeOptions().subscribe({
      next: (options: any[]) => {
        this.payTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getCarrierPaymentTypeOptions().subscribe({
      next: (options: any[]) => {
        this.carrierPaymentTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getBookingTypeOptions().subscribe({
      next: (options: any[]) => {
        this.bookingTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getCarTypeOptions().subscribe({
      next: (options: any[]) => {
        this.carTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getChargeOptions().subscribe({
      next: (options: any[]) => {
        this.chargeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getDeliveryTypeOptions(false).subscribe({
      next: (options: any[]) => {
        this.deliveryTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getDeliverySubTypeOptions('O').subscribe({
      next: (options: any[]) => {
        this.deliverSubTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getIncoTermOptions().subscribe({
      next: (options: any[]) => {
        this.incoTermOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getBookingStatusOptions().subscribe({
      next: (options: any[]) => {
        this.bookingStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: (options: any[]) => {
        this.shipMethodOptions = options.map((x) => ({
          label: `${x.optionCode}-${x.optionDesc}`,
          value: x.optionCode,
        }));
      },
    });

        this.facilityService.getAllVendorOptions().subscribe({
          next: result => {
            this.vendorOptions = [...result].map((x: any) => {
              return {
                label: `${x.optionCode}-${x.optionDesc}`,
                value: x.optionCode,
              };
            });
          }
        });

    const bookingNo = this.routeStateService.getCurrent()?.data?.bookingNo;
    this.bookingService.getBookingHeaderDetail(bookingNo).subscribe({
      next: (result) => {
        this.bookingModel = result;
        console.log(result);
        this.bookingModel.tmpCarSeq = this.bookingModel.carSeq?.slice(-4);

        if (this.bookingModel.deliveryType.indexOf('(') > -1) {
          this.bookingModel.deliveryType = this.bookingModel.deliveryType
            .substring(0, this.bookingModel.deliveryType.indexOf('('))
            .toUpperCase();
        } else {
          this.bookingModel.deliveryType =
            this.bookingModel.deliveryType.toUpperCase();
        }

        this.bookingService
          .getBookingDetail(this.laasSetting.facility, bookingNo)
          .subscribe({
            next: (result) => {
              this.isShowEditBtn = !['C'].includes(
                this.bookingModel.bookingStatus
              );
              this.isShowEditRelatedBillBtn =
                !['C'].includes(this.bookingModel.bookingStatus) &&
                this.permissionCodes.includes(
                  PermissionConstants.EditBookingRelatedBilling
                );
              this.isShowCancelBtn =
                !['C', '5', '2'].includes(this.bookingModel.bookingStatus) &&
                this.bookingModel.deliveryType != 'DECLARATION' &&
                isNullOrEmpty(this.bookingModel.whNo) &&
                this.permissionCodes.includes(PermissionConstants.CancelBooking);
              this.isShowUpdateBtn = ['0'].includes(
                this.bookingModel.bookingStatus
              );
            },
            error: (err: HttpErrorResponse) => {
              this.toastErrorMessage(err.error);
            },
          });

        this.dropdownOptionService
          .getLetterOrgOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.letterHeadOptions = options.map((x) => ({
                label: x.legalEntityOUName,
                value: x.legalEntityOUCode,
              }));
              this.billCorpOptions = options.map((x) => ({
                label: x.billOUName,
                value: x.billOUCode,
              }));
            },
          });
        this.dropdownOptionService
          .getForwarderOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.forwarderOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode,
              }));
            },
          });
        this.dropdownOptionService
          .getPickupLocationOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.pickupLocationOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode,
              }));
            },
          });
        this.dropdownOptionService
          .getCarSeqOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.carSeqOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode?.replace(':', ''),
              }));
            },
          });
        this.dropdownOptionService
          .getAreaOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.rfqAreaOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode,
              }));
            },
          });
        this.dropdownOptionService.getFacilityOptions().subscribe({
          next: (options: any[]) => {
            this.facilityOptions = options.map((x) => ({
              label: x.optionDesc,
              value: x.optionCode,
            }));
          },
        });
        this.dropdownOptionService
          .getAirPortOptions(this.bookingModel.toCity)
          .subscribe({
            next: (options: any[]) => {
              this.toAirportOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode,
              }));
            },
          });
      },
    });

    // rbac to maintain this page
    let canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.dropdownOptionService.getCountryOptions().subscribe({
      next: (options: any[]) => {
        this.countryOptions = options.map((x) => ({
          label: x.countryName,
          value: x.countryCode,
        }));
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.cityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
      },
    });

    this.dropdownOptionService.getAllAreaOptions().subscribe({
      next: (options: any[]) => {
        this.toAreaOptions = options.map((x) => ({
          label: x.rfqAreaName,
          value: x.rfqAreaCode,
        }));
      },
    });
  }

  editBtnClick(event: any): void {
    this.routeStateService.navigateTo(
      '/TransportOperation/BookingHeaderEdit',
      this.bookingModel
    );
  }

  cancelConfirm(event: any, bookingNo: string): void {
    this.bookingService.cancelBookingCheck(bookingNo).subscribe({
      next: (result: any) => {
        if (result?.length > 0) {
          let doNos = result.join(',  ');

          this.confirmationService.confirm({
            message: `${doNos} ${this.containerCheckDescription}`,
            rejectVisible: true,
            accept: () => {
              this.cancelBooking(event, bookingNo);
            },
            reject: () => {
              this.confirmationService.close();
            },
          });
        } else {
          this.confirmationService.confirm({
            message: '確定取消此筆Booking?',
            header: '確定取消',
            accept: () => {
              this.cancelBooking(event, bookingNo);
            },
            reject: () => {
              this.confirmationService.close();
            },
          });
        }
      },
      error: (err) => {
        this.toastErrorMessage(err.error);
      },
    });
  }

  cancelBooking(event: any, bookingNo: string): void {
    this.loader.show();
    this.bookingService
      .cancelBooking(
        bookingNo,
        this.userProfile.userName,
        this.bookingModel.facility
      )
      .pipe(finalize(() => this.loader.hide()))
      .subscribe({
        next: () => {
          this.toastService.success('取消成功');
          const resultObj = {
            bookingNoList: [bookingNo],
          };
          this.routeStateService.navigateTo(
            '/TransportOperation/BookingSearch',
            resultObj
          );
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  updateBtnClick(event: any): void {
    this.translateService.get('BoookingSearch.Confirm.IfRefresh').subscribe({
      next: (result) => {
        this.confirmationService.confirm({
          message: result,
          accept: () => {
            this.updateAddress(event);
          },
          reject: () => {
            this.confirmationService.close();
          },
        });
      },
    });
  }

  updateAddress(event: any): void {
    const bookingNo = this.routeStateService.getCurrent().data.bookingNo;
    this.bookingService.addressInfoRefresh(bookingNo).subscribe({
      next: (result) => {
        this.translateService
          .get('BoookingSearch.Success.UpdateSuccess')
          .subscribe({
            next: (result) => {
              this.toastService.success(result);
            },
          });

        location.reload();
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
      },
    });
  }

  showEditRelatedBillDialog(val: boolean): void {
    if (!val) {
      this.isShowEditRelatedBill = val;
      this.ngOnInit();
      return;
    }

    const bookingNo = this.routeStateService.getCurrent().data.bookingNo;
    this.billService.getBillingStatus(bookingNo).subscribe({
      next: (result) => {
        if (result) {
          for (const status of result.distinct()) {
            if (!['0', 'H'].includes(status)) {
              this.toastErrorMessage(
                this.translateService.instant(
                  'BookingHeaderDetails.Message.BillingStatusStageCannotBeModified'
                )
              );
              val = false;
              break;
            }
          }
        }
        this.isShowEditRelatedBill = val;
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
        this.isShowEditRelatedBill = val;
      },
    });
  }
}
